<template>
  <CDCConfirmationPage
    :use-confirmation-logo="whitelabelUseConfirmationLogo"
    :confirmation-page-image="whitelabelConfirmationPageImage"
  >
    <template #callItems>
      <div v-for="(item, i) in items" :key="i" class="items">
        <div class="bullet-point">
          {{ i + 1 }}
        </div>
        <div class="bullet-item">
          {{ item }}
        </div>
      </div>
    </template>
  </CDCConfirmationPage>
</template>

<script>
import { mapState } from 'vuex'
import CDCConfirmationPage from '@mic/frontend/views/CDCConfirmationPage'

const whitelabel = require('../../whitelabel.config')

export default {
  name: 'CallbackConfirmation',
  components: {
    CDCConfirmationPage
  },

  data () {
    return {
      items: [
        'We use your information to recommend the best packages from our entire panel.',
        'Your business connectivity expert will call to talk through your options.',
        "Once you choose your preferred package, we'll take care of the switch."
      ],
      whitelabelUseConfirmationLogo:
        whitelabel[process.env.VUE_APP_BRAND].useConfirmationLogo,
      whitelabelConfirmationPageImage:
        whitelabel[process.env.VUE_APP_BRAND].confirmationPageImage,
      whitelabelUtag: whitelabel[process.env.VUE_APP_BRAND].utag
    }
  },
  computed: {
    ...mapState(['CallBack']),
    scheduled () {
      return this.CallBack.contactDateTime
    },
    introText () {
      return this.scheduled
        ? 'Your personal telecoms expert will call you soon.'
        : 'One of our business connectivity experts will call you in a few minutes.'
    }
  }
}
</script>
